import React from "react";
import { createRoot } from "react-dom/client";
import "./utils/i18n";

import App from "./App";
import { keycloakConfig } from "./providers/authProvider";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { RefineSnackbarProvider } from "@refinedev/mui";

/*
Sentry.init({
  dsn: "https://e393389e3e4da277bf1045fc755a91da@o4509848194449408.ingest.us.sentry.io/4509848240848896",
  sendDefaultPii: true,
  enableLogs: true,
  release: config.ENV,
});
*/

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

root.render(
  <ReactKeycloakProvider authClient={keycloakConfig}>
    <RefineSnackbarProvider>
      <App />
    </RefineSnackbarProvider>
  </ReactKeycloakProvider>,
);
